import React, { FunctionComponent, useEffect } from 'react';
import { useStore, StoreProviderValue } from '../../store/storeContext';
import { AIChatbotKeyForSidenav, SideNavActiveItemStoreKey } from '../ViewConstant';
import { AIChatbotProvider } from '../../components/api-docs/AIChatbot/AIChatbotContext';
import AIChatbot from '../../components/api-docs/AIChatbot/AIChatbot';
import { PlatformsProvider } from '../../components/api-docs/Platforms/PlatformsContext';

const AIChatbotView: FunctionComponent = () => {
    const { updateStore } = useStore() as StoreProviderValue;
    useEffect(() => {
        updateStore(AIChatbotKeyForSidenav, SideNavActiveItemStoreKey);
    }, []);
    return (
        <div className="w-full h-full">
            <AIChatbotProvider>
                <PlatformsProvider>
                    <AIChatbot />
                </PlatformsProvider>
            </AIChatbotProvider>
        </div>
    );
};

export default AIChatbotView;
